import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { apiErrorHandler } from '../../utils/errorHandler';
import { openSnackBar } from '../../redux/actions/snackbar.actions';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import { getApiUrl } from '../../utils/apiUrls';
import { Link, useSearchParams } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';

const VerifyMail = ({ t, id, refId }) => {
    const dispatch = useDispatch();
    const env = useSelector(state => state?.env);
    const recaptchaRef = React.useRef(null);
    const captchaWidget = React.useMemo(() => {
        if (env?.RECAPTCHA?.ENABLE_RECAPTCHA) {
            return (
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={env?.RECAPTCHA?.SITE_KEY}
                    size="invisible"
                    className="cm-recaptcha"
                />
            );
        }
        return null;
    }, [env?.RECAPTCHA?.ENABLE_RECAPTCHA]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [disable, setDisable] = React.useState(false);
    const windowSize = useWindowSize();

    const [searchParams] = useSearchParams();
    const getLang = searchParams.get('lang');

    const handleFormSubmit = (e) => {
        e.preventDefault();
    }

    const triggerCaptchaAndResend = async () => {
        if (isLoading) return;
        setIsLoading(true);
        if (env?.RECAPTCHA?.ENABLE_RECAPTCHA) {
            const token = await recaptchaRef.current.executeAsync();
            recaptchaRef.current?.reset();
            if (!token) {
                dispatch(openSnackBar({ msg: t('captcha_verification_failed'), type: 'error' }));
                setIsLoading(false);
                return;
            }
            handleResendMail(token);
        } else {
            handleResendMail(null);
        }
    };

    const handleResendMail = async (recaptchaToken) => {
        try {
            setIsLoading(true);
            const res = await axios.post(`${getApiUrl('resendActivationLink')}?id=${id}${ `&lang=${!!getLang ? getLang : 'en'}`}${refId ? `${getLang ? '&': '?'}refId=${refId}`  : '' }`, { recaptchaToken });
    
            if(res.data.status === "SUCCESS") {
                setIsLoading(false);
                setDisable(true);
                dispatch(openSnackBar({
                    msg: t(res.data.message),
                    type: 'success'
                }));
            } else {
                throw Error(res.data);
            }
        } catch (error) {
            setIsLoading(false);
            recaptchaRef.current?.reset();
            const errObj = apiErrorHandler(error);

            dispatch(openSnackBar({
                msg: t(errObj.statusText),
                type: 'error'
            }))
        }
    }

    return(
        <>
            <div className="cm-auth-form cm-verify-mail-form d-flex" onSubmit={handleFormSubmit}>
                <p className='cm-verify-mail-txt my-0 fw-medium text-blue-gray-500'>{ t("didnt_receive_email") }</p>
                {!disable ? 
                    <div className={`cm-resend-verify-mail-wrap d-flex align-items-center ms-4 cm-pointer ${windowSize?.isMobile ? "text-white" : "text-action-blue"}`} onClick={triggerCaptchaAndResend}>
                        <span className='cm-sm-txt fw-medium'>{ t("resend_email") }</span>
                        <FontAwesomeIcon icon={regular("angle-right")} className="ps-2" />
                    </div>
                    :
                    <div className='cm-resend-verify-mail-wrap d-flex align-items-center ms-4'>
                        <FontAwesomeIcon icon={regular("circle-check")} className="text-success pe-2" />
                        <span className='text-success cm-sm-txt fw-medium'>{ t("email_sent_verification") }</span>
                    </div>
                }
            </div>
            <Link className={`cm-back-login-btn border border-blue-gray-300 cm-sm-txt fw-medium ${windowSize?.isMobile ? "text-white" : "text-blue-800"}`} to={`/login${!!getLang ? `?lang=${getLang}` : ''}${refId ? `${refId ? `${getLang ? '&' : '?'}ref=${refId}` : ''}` : ''}`}>{t("back_to_login")}</Link>
            {captchaWidget}
        </>
    )

}

export default VerifyMail;